import {useDirectus} from '~/composables/directus'
import {useAuth} from '~/store/auth'
import {useSuivi} from "~/store/suivi";

export default defineNuxtRouteMiddleware(async (to, from) => {

    if (!useDirectus().client) {
        useDirectus().init()
    }

    if(to.name !== 'id')
    {
        useSuivi().pageTitle = 'Suivi de projet'
    }

    if (to.name !== 'login' && to.name !== 'admin-accept-invite' && to.name !== 'reset-password' && to.name !== 'admin-reset-password') {
        try {

            await useDirectus().refresh()
            await useAuth().getUser()

            if (!useAuth().user) {
                localStorage.setItem('redirect_after_login', to.path)
                return navigateTo('/login')
            } else if (localStorage.getItem('redirect_after_login')) {
                let redirectTo = localStorage.getItem('redirect_after_login')
                localStorage.removeItem('redirect_after_login')
                return navigateTo(redirectTo)
            }


        } catch (e) {
            localStorage.setItem('redirect_after_login', to.path)
            return navigateTo('/login')
        }
    }
})
